import { useEffect, useState } from "react";

import Table from "@mui/material/Table";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/material";
import { getobj } from "../apicall/apicall";
import { timeStamp } from "../apicall/commonFunction";
import { Pagination } from "@mui/material";

export default function Telemetry(props) {
  const [telemetry, settelemetry] = useState();
  const [load, setload] = useState(true);
  const [loaded, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [totalpage, setpaget] = useState();

  const handlePagechange = (event, value) => {
    setloaded(true);
    setpage(value);
    //console.log(event,value)
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/telemetry/" +
      props.id +
      "/?page=" +
      value;
    const d = getobj(url);
    d.then(function (res) {
      settelemetry(res.results);
      setloaded(false);
    });
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/telemetry/" +
      props.id +
      "/?page=1";
    const d = getobj(url);
    d.then(function (res) {
      settelemetry(res.results);
      if (res.results.length > 0) {
        setload(false);
      }
      if (res.count % 5 > 0) {
        setpaget(Math.floor(res.count / 5) + 1);
      } else {
        setpaget(Math.floor(res.count / 5));
      }

      setloaded(false);
    });
  }, [props.refresh, props.id]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  return (
    <div>
      {loaded ? (
        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
      ) : !load ? (
        <Box>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>Date</b>
                  </StyledTableCell>

                  <StyledTableCell>
                    <b>Data</b>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {telemetry &&
                  telemetry.map((tel) => (
                    <StyledTableRow key={tel.id}>
                      <StyledTableCell>
                        {Object.keys(tel.measured_data).includes("imei")
                          ? timeStamp(parseInt(tel.utc, 16))
                          : Object.keys(tel.measured_data).includes("la")
                          ? timeStamp(tel.utc).split(",")[0] +
                            ", " +
                            timeStamp(tel.utc).split(",")[1]
                          : timeStamp(tel.utc)}
                      </StyledTableCell>
                      <StyledTableCell>
                        <Box>
                          {JSON.stringify(tel.measured_data)
                            .slice(1, -1)
                            .split(",")
                            .map((i) => {
                              return (
                                <div>
                                  {i}
                                  <br />
                                </div>
                              );
                            })}
                        </Box>
                        {JSON.stringify(tel.measured_data)[-1]}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <h6 style={{ fontFamily: "Roboto" }}>No Data available</h6>
      )}
      {/* {load ? (
        loaded ? (
          <img src="https://zewa-logo-bucket.s3.us-west-2.amazonaws.com/logo/Spinner-1s-200px.gif" />
        ) : (
          <Box>
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Date</b>
                    </StyledTableCell>

                    <StyledTableCell>
                      <b>Data</b>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {telemetry &&
                    telemetry.map((tel) => (
                      <StyledTableRow key={tel.id}>
                        <StyledTableCell>
                          {Object.keys(tel.measured_data).includes("imei")
                            ? timeStamp(parseInt(tel.utc, 16))
                            : timeStamp(tel.utc)}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box>
                            {JSON.stringify(tel.measured_data)
                              .slice(1, -1)
                              .split(",")
                              .map((i) => {
                                return (
                                  <div>
                                    {i}
                                    <br />
                                  </div>
                                );
                              })}
                          </Box>
                          {JSON.stringify(tel.measured_data)[-1]}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )
      ) : (
        <h6 style={{ fontFamily: "Roboto" }}>No Data available</h6>
      )} */}
      <Pagination
        count={totalpage}
        page={page}
        variant="outlined"
        color="primary"
        onChange={handlePagechange}
      />
    </div>
  );
}
